import {createSlice} from "@reduxjs/toolkit";


const initialState = {
    listLoading: false,
    actionsLoading: false,
    settingSelection: false,
    selectedDept: {},
    selectedService: {},
    selectedServiceItem: {},
    selectedProvince: {},
    selectedRegion: {},
    lastError: null
};

export const callTypes = {
    list: "list",
    action: "action",
    select: "select",
};
  

const catalogueSlice = createSlice({
    name: 'catalogue',
    initialState: initialState,
    reducers: {
        catchError: (state, action) => {
            state.lastError = `${action.type}: ${action.payload.error}`;
            if (action.payload.callType === callTypes.list) {
                state.listLoading = false;
            } else if (action.payload.callType === callTypes.select) {
                state.settingSelection = false;
            } else {
                state.actionsLoading = false;
            }
        },
        startCall: (state, action) => {
            state.lastError = null;
            if (action.payload.callType === callTypes.list) {
                state.listLoading = true;
            } else if (action.payload.callType === callTypes.select) {
                state.settingSelection = true;
            } else {
                state.actionsLoading = true;
            }
        },
        resetState: (state, action) => {
            state.listLoading = false;
            state.actionsLoading = false;
            state.settingSelection = false;
            state.selectedDept = {};
            state.selectedService = {};
            state.selectedServiceItem = {};
            state.selectedRegion = {};
            state.lastError = null;
        },
        selectedDept: (state, action) => {
            state.selectedDept = action.payload.dept;
            state.settingSelection = false;
        },
        selectedService: (state, action) => {
            state.selectedService = action.payload.service;
            state.settingSelection = false;
        },
        selectedServiceItem: (state, action) => {
            state.selectedServiceItem = action.payload.serviceItem;
            state.settingSelection = false;
        },
        selectedProv: (state, action) => {
            state.selectedProvince = action.payload.province;
            state.settingSelection = false;
        },
        selectedRegion: (state, action) => {
            state.selectedRegion = action.payload.region;
            state.settingSelection = false;
        },
    }
});

export const {actions} = catalogueSlice;
export const {reducer} = catalogueSlice;